module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prices":"Prices","calculator":"Calculator","signUp":"Get started with Huntica"}}')
  delete Component.options._Ctor
}
